var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vun8y3c7ea",
    d: "M10.798 5.602c.392-.39.416-1.01.07-1.427l-.07-.077L7.287.62c-.833-.827-2.182-.827-3.015 0L.76 4.098C.366 4.487.34 5.107.686 5.525l.07.077c.42.417 1.096.417 1.515.001L4.715 3.18v8.466c0 .589.477 1.066 1.065 1.066.59 0 1.066-.477 1.066-1.066V3.18l2.438 2.423c.419.416 1.095.416 1.514 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "894kscwxjc",
    d: "M14.38.899V3.98H1.798V.9c0-.497-.403-.899-.9-.899C.403 0 0 .402 0 .899V3.98c0 .989.809 1.798 1.798 1.798H14.38c.989 0 1.798-.81 1.798-1.798V.9c0-.497-.403-.899-.899-.899s-.899.402-.899.899z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -1119) translate(105 119) translate(160 992) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5A5",
    transform: "translate(-309 -1119) translate(105 119) translate(160 992) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -1119) translate(105 119) translate(160 992) translate(44 8) translate(4 4) translate(4.444 4.444) translate(5.778 3.467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k65shii94b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vun8y3c7ea"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E5E5E5",
    xlinkHref: "#vun8y3c7ea"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#k65shii94b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H36.978V36.978H0z",
    transform: "translate(-12.198 -10.015)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -1119) translate(105 119) translate(160 992) translate(44 8) translate(4 4) translate(4.444 4.444) translate(3.467 13.867)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sthyfp7xud",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#894kscwxjc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E5E5E5",
    xlinkHref: "#894kscwxjc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#sthyfp7xud)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H36.978V36.978H0z",
    transform: "translate(-2.311 -20.8)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleFileUpload);
export default __webpack_public_path__ + "static/media/singleFileUpload.e0de1796e03552bee6ccfff46c36274d.svg";
export { ForwardRef as ReactComponent };